import {
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  Label,
  Row,
  InputGroup,
} from "reactstrap";
import { AvForm } from "availity-reactstrap-validation";
import PropTypes from "prop-types";
import styled from "styled-components";
import React, { useState } from "react";
import EditPlanItems from "./EditPlanItems";

import { Container } from "reactstrap";
import Breadcrumbs from "../../../../../components/Common/Breadcrumb";
import {
  addPlanBulk,
  getPlanFilterData,
} from "../../../../../store/plans/actions";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import CustomMultipleDateRange from "../../../../../components/CustomMultipleDateRange/CustomMultipleDateRange";
import CustomMiniLoader from "../../../../../components/CustomMiniLoader/CustomMiniLoader";

const EditPlansForm = props => {
  const currentDate = new Date(new Date().setDate(1));
  const [isFormSubmit, setIsFormSubmit] = React.useState(false);
  const [date, setDate] = React.useState({
    start_date: new Date(new Date().setDate(1)).toJSON().split("T")[0],
    end_date: new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      currentDate.getDate(),
      0
    ).toJSON().split("T")[0],
  });
  const createIndex = () =>
    Math.random().toString(36).substring(2, 15) +
    Math.random().toString(36).substring(2, 15);
  const [plan, setPlan] = useState([
    {
      idx: createIndex(),
    },
  ]);

  React.useEffect(() => {
    props.getPlanFilterData();
  }, []);

  const itemSettings = (type, idx) => {
    switch (type) {
      case "create":
        return setPlan([
          ...plan,
          {
            idx: createIndex(),
          },
        ]);
      case "delete":
        return setPlan(
          plan.filter(i => {
            return i.idx !== idx;
          })
        );
    }
  };
  const handleValidOrderSubmit = (e, errors, params) => {
    setIsFormSubmit(true);
    if (errors?.length === 0) {
      const items = [];
      let data = {
        ...params,
      };

      for (const key in data) {
        if (data[key] === "") {
          delete data[key];
        } else if (Array.isArray(data[key])) {
          data[key] = data[key].map(i => i.value);
        } else if (data[key]?.value) {
          data[key] = data[key].value;
        } else if (!!Number(data[key])) {
          data[key] = +data[key];
        }
      }

      for (const key in data) {
        const split = key.split("|");
        if (split.length === 2) {
          const k = split[0];
          let suffix = items.find(i => i.id === split[1])?.id;
          if (suffix !== undefined) {
            let idx = items.findIndex(i => i.id === suffix);
            items[idx][k] = params[key];
            items[idx]["date_from"] = date.start_date;
            items[idx]["date_to"] = date.end_date;
          } else {
            items.push({
              id: split[1],
              [k]: params[key],
              date_from: date.start_date,
              date_to: date.end_date,
            });
          }
        }
      }

      data = items.map(i => {
        return {
          group: i.name,
          account_manager: i.account_manager.value,
          offer: i.offer,
          plan: i.plan,
          corrected_plan: i.corrected_plan,
          date_from: i.date_from,
          date_to: i.date_to,
        };
      });
      props.addPlanBulk(data, props.history);
    }
  };

  const onlyMonthFilterChange = (dateVal) => {
    let currentDate = new Date(dateVal.value);
    let lastDay = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      currentDate.getDate(),
      0
    );

    const data = {
      start_date: new Date(currentDate).toJSON().split("T")[0],
      end_date: new Date(lastDay).toJSON().split("T")[0],
    };

    setDate(data)
  };

  return (
    <div className="page-content">
    <ModifiedMetaTags title="Add plans | Mobihunter" />
    
      <Container fluid>
        <Breadcrumbs
          title="Plans"
          breadcrumbItem={`Add plans`}
          link={`/project-manager-plans?start_date=${props.profitFilterData.start_date}&end_date=${props.profitFilterData.end_date}#plans`}
        />
        <Row className="d-flex justify-content-center mt-10">
          <Col lg={9}>
            <AvForm className="needs-validation" onSubmit={handleValidOrderSubmit}>
              <Card className="mb-0">
                <CardBody>
                  <Row>
                    <Col lg={2}>
                      <PickerStyled>
                        <Label htmlFor="">Date:</Label>
                        <FormGroup className="mb-3">
                          <CustomMultipleDateRange
                            placeholder="Select date..."
                            name="month"
                            // value={{
                            //   start_date: date.start_date,
                            //   end_date: date.end_date,
                            // }}
                            value={date.start_date}
                            datePickerType={"calendar-with-static"}
                            errorText="Date is required!"
                            onChange={e => onlyMonthFilterChange(e)}
                            monthTextFormat
                            required
                          />
                        </FormGroup>
                      </PickerStyled>
                    </Col>
                  </Row>
                  <Label htmlFor="">Plans:</Label>
                  {plan.map((i, idx) => (
                    <EditPlanItems
                      key={idx}
                      filter_data={props.filter_data}
                      data={i}
                      num={plan.length}
                      keys={i.idx}
                      onDelete={() => itemSettings("delete", i.idx)}
                      isFormSubmit={isFormSubmit}
                    />
                  ))}
                  <Row>
                    <div className="text-start my-0 mt-2">
                      <Button
                        color="primary"
                        type="button"
                        onClick={() => itemSettings("create")}
                      >
                        <i className="mdi mdi-plus" /> Add plan
                      </Button>
                    </div>
                  </Row>
                </CardBody>
              </Card>
              <Row className="mt-3 mb-3">
                <Col>
                  <ButtonContainer>
                    {props.bulk_loader ? (
                      <div>
                        <CustomMiniLoader
                          className="fade-in-custom-animate"
                          style={{ padding: "10px", minWidth: "143px" }}
                          status
                          text="Please wait"
                        />
                      </div>
                    ) : (
                      <div>
                        <button
                          type="button"
                          onClick={() =>
                            props.history.push(
                              `/project-manager-plans?start_date=${props.profitFilterData.start_date}&end_date=${props.profitFilterData.end_date}#plans`
                            )
                          }
                          className="btn btn-outline-primary save-user fade-in-custom-animate"
                        >
                          Back to plans
                        </button>
                        <button
                          type="submit"
                          className="btn btn-success save-user fade-in-custom-animate ms-3"
                        >
                          Save changes
                        </button>
                      </div>
                    )}
                  </ButtonContainer>
                </Col>
              </Row>
            </AvForm>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

const PickerStyled = styled(InputGroup)`
  flex-direction: column;

  p {
    margin-bottom: 6px;
  }

  input {
    width: 100% !important;
    height: 38px;
    font-size: 12px;
    background: #fff !important;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: end;
  text-align: right !important;
`;import ModifiedMetaTags from '../../../../../components/ModifiedMetaTags/index';


EditPlansForm.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.node,
    }).isRequired,
  }).isRequired,
  history: PropTypes.object.isRequired,
  filter_data: PropTypes.object.isRequired,
  readOnly: PropTypes.bool,
  addPlanBulk: PropTypes.func.isRequired,
  profitFilterData: PropTypes.object.isRequired,
  getPlanFilterData: PropTypes.func.isRequired,
  bulk_loader: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  filter_data: state.PlanList.filter_data,
  profitFilterData: state.PlanList.profitFilterData,
  bulk_loader: state.PlanList.bulk_loader,
});

export default connect(mapStateToProps, {
  addPlanBulk,
  getPlanFilterData,
})(withRouter(EditPlansForm));
